import { useState, useEffect } from 'react';
import axios from 'axios';
import HeroSection from '../components/landing/HeroSection';
import IntroSection from '../components/landing/IntroSection';
import SponsorsSection from '../components/landing/SponsorsSection';
import MediaStorySection from '../components/landing/MediaStorySection';
import ExperienceSection from '../components/landing/ExperienceSection';
import CTASection from '../components/landing/CTASection';
import FooterSection from '../components/landing/FooterSection';
import MarqueeBanner from '../components/landing/MarqueeBanner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

function preloadAllImages(mediaItems) {
  mediaItems.forEach(item => {
    if (item.media_type === 'image' && item.url) {
      const url = item.url.startsWith('/api') ? `${BACKEND}${item.url}` : item.url;
      const img = new Image();
      img.src = url;
    }
  });
}

export default function LandingPage() {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const res = await axios.get(`${API}/media`);
        setMedia(res.data);
        preloadAllImages(res.data);
      } catch (err) {
        console.error('Failed to fetch media:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchMedia();
  }, []);

  const bySection = (section) => media.filter(m => m.section === section);

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black flex items-center justify-center z-50" data-testid="loading-screen">
        <div className="text-center">
          <h1 className="font-heading text-5xl text-gold tracking-[0.3em] gold-pulse">OZFEST</h1>
          <div className="w-16 h-[1px] bg-gold/40 mx-auto mt-6" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-black text-white min-h-screen font-body pb-14" data-testid="landing-page">
      <HeroSection media={bySection('hero')} />
      <IntroSection />
      <MediaStorySection media={bySection('media_story')} />
      <SponsorsSection sponsors={bySection('sponsors')} />
      <ExperienceSection media={bySection('experience')} />
      <CTASection />
      <FooterSection />
      <MarqueeBanner />
    </div>
  );
}
